import type {usePropertyDefinitionForm} from '@github-ui/custom-properties-core/hooks/use-property-definition-form'
import type {useRefs} from '@github-ui/custom-properties-core/hooks/use-refs'

import {ApplyValueStep} from './ApplyValueStep'
import {DefinitionStep} from './DefinitionStep'
import type {RepoPropertyDefinitionWithValueSchema} from '../hooks/use-definition-form-with-value'
import type {Repository} from '../types'

type RefProps = ReturnType<typeof useRefs<RepoPropertyDefinitionWithValueSchema>>
type FormProps = ReturnType<typeof usePropertyDefinitionForm<RepoPropertyDefinitionWithValueSchema>>

interface Props extends FormProps, RefProps {
  sourceName: string
  repositories: Repository[]
  step: number
}

export function MultiStepForm({step, repositories, sourceName, ...formProps}: Props) {
  if (step === 0) {
    return <DefinitionStep {...formProps} />
  } else if (step === 1) {
    return <ApplyValueStep sourceName={sourceName} repositories={repositories} {...formProps} />
  } else {
    throw new Error(`Unsupported form step: ${step}`)
  }
}
